// src/constants/config.ts
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://therealproject.xyz';
export const ANALYTICS_API_URL = import.meta.env.VITE_ANALYTICS_API_URL || 'http://localhost:3011';

console.log('[Config] API Base URL:', API_BASE_URL);